// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__5ztuc","approved":"Status_approved__2WNbk","rejected":"Status_rejected__3ZTbZ","expired":"Status_expired__1vpxy","label":"Status_label__21CbP"};